export const downFileBlob = function (res) {
  //处理文件名
  let fileName = 'downFile.xls';
  try {

    fileName = res.headers['content-disposition'].split('=')[1];
    console.log(fileName);
    fileName = decodeURIComponent(fileName);
    console.log(fileName);
  } catch (error) {
    console.log(error);
  }
  let a = document.createElement('a');
  ;
  let blob = new Blob([res.data], {
    type: 'application/vnd.ms-excel'
  });
  // 区分ie浏览器
  if ('msSaveOrOpenBlob' in navigator) {
    //兼容ie
    window.navigator.msSaveOrOpenBlob(blob, fileName);
    return;
  } else {
    let objectUrl = URL.createObjectURL(blob);
    a.setAttribute('href', objectUrl);
    a.setAttribute('download', fileName);
    a.click();
    a = null;
  }
};
